import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useClickOutside from '@hooks/useClickOutside';

import { allFilterPages, formatRangeValue } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterInput from '@features/filter/v2/FilterInput';
import FilterName from '@features/filter/v2/FilterName';

import { clearSelectedFilterName, storeItemInGlobalFilter } from '@store/actions/FilterAction';

const OfferPrice = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const { selectedCheckboxField } = useSelector((store) => store.slectedCheckBoxFieldStore);
	const [offerPriceInputValue, setOfferPriceInputValue] = useState({ min: '', max: '' });
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;
	const dispatch = useDispatch();
	const wrapperRef = useRef(null);
	const [activeLayer, setActiveLayer] = useState('');

	const onOutSideClick = () => {
		if (selectedCheckboxField === 'OFFER_PRICE') dispatch(clearSelectedFilterName());
	};

	useClickOutside(wrapperRef, onOutSideClick);

	useEffect(() => {
		setOfferPriceInputValue({ min: '', max: '' });
	}, [multiLevelFilterStore?.multiLevelFilters[1]?.name]);

	useEffect(() => {
		onFetchCompositionData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.PRODUCT_LIST]: dependentFilterList?.pickAndChooseBrandList
	};

	const onFetchCompositionData = async () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return {
				id: item?.id,
				name: item?.name,
				hasInputField: true,
				count: item?.count
			};
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};

	const onApplyChange = () => {
		let data = {
			name: 'offerPriceList',
			key: offerPriceInputValue,
			minPrice: parseFloat(offerPriceInputValue.min),
			maxPrice: parseFloat(offerPriceInputValue.max),
			brandId: activeLayer.id,
			value: `${activeLayer.name}: ${formatRangeValue(offerPriceInputValue, '$', 'left')}`,
			identifier: 'offerPriceList',
			type: 'OFFER_PRICE'
		};

		dispatch(storeItemInGlobalFilter(data));
		onClearInput();
		onOutSideClick();
	};

	const onClearInput = () => {
		setOfferPriceInputValue({ min: '', max: '' });
	};

	const onChangeComposition = (e) => {
		const { name, value } = e.target;
		setOfferPriceInputValue((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const getActiveLebelId = (option) => {
		setActiveLayer(option);
	};

	return (
		<div ref={wrapperRef}>
			<FilterName type="OFFER_PRICE" data={data} />
			<Checkbox
				data={data}
				type="OFFER_PRICE"
				handleSearch={handleSearch}
				nextFilterLevel={3}
				onSelectedOption={getActiveLebelId}
			/>

			{selectedField?.selectedCheckboxField === 'OFFER_PRICE' &&
				[3].includes(currentSelectedFilterLevel) && (
					<div className={`filter-submenu  scroll-y-label`} style={{ marginLeft: '235px' }}>
						<FilterInput
							onApplyHandler={onApplyChange}
							onChangeHandler={onChangeComposition}
							inputValue={offerPriceInputValue}
							placeHolderOne="Min"
							placeHolderTwo="Max"
							type="OFFER_PRICE"
							onClearInputFields={onClearInput}
						/>
					</div>
				)}
		</div>
	);
};

export default OfferPrice;
